import { render, staticRenderFns } from "./Color.vue?vue&type=template&id=4d6848a0&"
import script from "./Color.vue?vue&type=script&lang=ts&"
export * from "./Color.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports